import React from 'react';
import { Route, Switch } from 'react-router-dom';

import {Horfex} from '../components/pages/home';
import Philosophie from '../components/pages/philosophy';
import Kontakt from '../components/pages/kontakt';
import Gallerie from '../components/pages/gallerie';
import Team from '../components/pages/team';
import Blog from '../components/pages/blog';
import SinglePost from '../components/pages/singlePost';
import Impressum from '../components/pages/impressum';
import Datenschutz from '../components/pages/datenschutz';
import Landingpage from '../components/pages/landingpage';

export const Routes = () => {
  return (
    <div>
      <Switch>
        <Route exact path="/" component={Landingpage} />
        <Route exact path="/horfex" component={Horfex} />
        <Route path="/philosophie" component={Philosophie} />
        <Route path="/kontakt/:id" component={Kontakt} />
        <Route path="/galerie" component={Gallerie} />
        <Route path="/team" component={Team} />
        <Route path="/blog/post/:id" component={SinglePost}/>
        <Route path="/blog" component={Blog} />
        <Route path="/impressum" component={Impressum} />
        <Route path="/datenschutz" component={Datenschutz} />
      </Switch>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/config/routes.js